import * as XLSX from 'xlsx';

export const handleExportToExcel = departmentData => {
  const currentDate = new Date().toLocaleDateString();
  const columnsHeadings = ['Военная часть', 'Кол-во устройств'];

  const data = [
    {
      title: `Статистика по устройствам военных частей на момент ${currentDate}`,
      items: departmentData,
    },
  ];

  const excelData = [];

  data.forEach(section => {
    excelData.push([section.title]);

    excelData.push(columnsHeadings);

    section.items.forEach(item => {
      excelData.push([item.name, item.value]);
    });

    excelData.push([]);
  });

  const ws = XLSX.utils.json_to_sheet(excelData);
  ws['!cols'] = columnsHeadings.map(heading => ({ wch: heading.length + 2 }));

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Статистика');

  XLSX.writeFile(wb, `Статистика_на_${currentDate.replaceAll('/', '-')}.xlsx`);
};
